export default __webpack_public_path__ + "0c3d9017adc0470b18d8f37734275b61.png";